function RepostingLedger() {
    return (
        <div>
            <h2>Reposting Ledger</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default RepostingLedger;